import { z } from 'zod';
export const PHOTO_ANGLES = ['front', 'left', 'right', 'top', 'crown', 'back', 'hairline'];
export const PHOTO_SESSION_KINDS = ['evaluation', 'pre_op', 'post_op', 'follow_up', 'other'];
/** Como tirar cada foto (mostrado no portal e na tela da equipe). */
export const ANGLE_GUIDE = {
    front: { label: 'Frente', tip: 'Rosto de frente, olhando para a câmera, cabelo penteado para trás.', helper: false },
    hairline: { label: 'Linha frontal', tip: 'Cabeça levemente abaixada, mostrando a linha do cabelo e as entradas.', helper: false },
    left: { label: 'Lado esquerdo', tip: 'Perfil esquerdo, orelha visível, olhando para a frente.', helper: true },
    right: { label: 'Lado direito', tip: 'Perfil direito, orelha visível, olhando para a frente.', helper: true },
    top: { label: 'Topo', tip: 'Foto de cima da cabeça, com o queixo encostado no peito.', helper: true },
    crown: { label: 'Coroa', tip: 'Parte de trás e de cima (redemoinho), cabeça levemente abaixada.', helper: true },
    back: { label: 'Nuca (área doadora)', tip: 'Parte de trás da cabeça, da nuca até o alto das orelhas.', helper: true },
};
export const SESSION_PRESETS = {
    evaluation: { title: 'Fotos para a avaliação', angles: ['front', 'hairline', 'left', 'right', 'top', 'crown', 'back'] },
    pre_op: { title: 'Fotos pré-operatórias', angles: ['front', 'hairline', 'left', 'right', 'top', 'crown', 'back'] },
    post_op: { title: 'Fotos do pós-operatório', angles: ['front', 'hairline', 'top', 'crown', 'back'] },
    follow_up: { title: 'Fotos de acompanhamento', angles: ['front', 'hairline', 'top', 'crown'] },
    other: { title: 'Fotos', angles: ['front'] },
};
export const createPhotoSessionSchema = z.object({
    kind: z.enum(PHOTO_SESSION_KINDS),
    title: z.string().trim().min(2).max(80).optional(),
    angles: z.array(z.enum(PHOTO_ANGLES)).min(1).max(7).optional(),
    /** avisar o paciente pelo WhatsApp com o link do portal */
    notify: z.boolean().default(true),
});
export const photoSchema = z.object({
    id: z.uuid(), sessionId: z.uuid(), angle: z.enum(PHOTO_ANGLES), url: z.string(),
    width: z.number().int().nullable(), height: z.number().int().nullable(),
    uploadedBy: z.enum(['patient', 'user']), uploadedByName: z.string().nullable(), createdAt: z.string(),
});
export const photoSessionSchema = z.object({
    id: z.uuid(), kind: z.enum(PHOTO_SESSION_KINDS), title: z.string(), angles: z.array(z.enum(PHOTO_ANGLES)),
    status: z.enum(['open', 'complete', 'cancelled']), createdAt: z.string(), completedAt: z.string().nullable(),
    notifiedAt: z.string().nullable(),
    /** foto atual de cada ângulo (a mais recente) */
    photos: z.array(photoSchema),
});
//# sourceMappingURL=photos.js.map